import { DateTime } from 'luxon';

export const getDateTime = (dateString, format) => DateTime.fromJSDate(new Date(dateString)).toFormat(format);
export const dateTime = (dateString, format) => DateTime.fromJSDate(new Date(dateString)).toFormat(format);

export const getDate = (dateString, format) => (dateString ? DateTime.fromJSDate(dateString).toFormat(format) : null);

export const getDateFromString = (
  dateString,
  format,
) => (dateString
  ? DateTime.fromISO(dateString, { zone: 'utc' }).toFormat(format)
  : null);

export const getIso = dateString => DateTime.fromJSDate(dateString || new Date()).toISO();

export const getNowDateTimeIso = () => DateTime.now().toISO();

export const getIsSameDay = (date1, date2) => (date2 && date1
  ? DateTime.fromJSDate(new Date(date1)).hasSame(
    DateTime.fromJSDate(new Date(date2)),
    'day',
  )
  : false);
